<app-logo-area [breadcrumbs]="[{'display': 'Content Platform', commands: ['/o', this.organization()?.id]}]"></app-logo-area>
<main>
  <app-headline-section [title]="'Search'"></app-headline-section>
  <app-filter-section [openByDefault]="true" [filtered]="searchResults.items" [formGroup]="filters">
    <form [formGroup]="filters" class="cl-form">
      <div class="row ">
        <div class="col-12">
          <input type="text" style="width: 100%" formControlName="t"
            placeholder="" autofocus>
          <p class="valid-feedback">Search terms are case-insensitive.</p>
        </div>
        <div class="col-12">
          <input type="text" style="width: 100%" formControlName="p"
            placeholder="">
          <p class="valid-feedback">Only results with this parent ID</p>
        </div>

      </div>
      <div class="row ">
        <div class="col-3">
          <select style="width: 100%" formControlName="r" class="form-select">
            <option value="">All</option>
            @for (s of storageRoots(); track s.id) {
              <option [value]="s.id">{{ s.name }}</option>
            }
          </select>
          <p class="valid-feedback">Select a storage root to search.</p>
        </div>
        <div class="col-3">
          <select style="width: 100%" formControlName="sd" class="form-select">
            <option [value]="''">Current files only</option>
            <option value="true">Show deleted</option>
          </select>
          <p class="valid-feedback">Select including deletion status.</p>
        </div>
        <div class="col-3">
          <input type="datetime-local" style="width: 100%" formControlName="d1">
          <p class="valid-feedback">No files older than</p>
        </div>
        <div class="col-3">
          <input type="datetime-local" style="width: 100%" formControlName="d2">
          <p class="valid-feedback">No files younger than</p>
        </div>

      </div>

    </form>

  </app-filter-section>

  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12">
          @if (searchResults.items.length < searchResults.total) {
            <p class="alert cl-alert-warning"
            role="alert">{{ searchResults.items.length }} of {{ searchResults.total }} shown</p>
          }
        </div>

        <div class="col-12">
          <table class="cl-table-data">
            <colgroup>
            <col span="1" style="width: 40px">
            <col span="1" style="width: 100%">
            <col span="1" style="width: 180px">
          </colgroup>
          <thead>
            <tr>
              <th class="cl-table-head cl-p-tiny ">
                <div>
                  Type
                </div>
              </th>
              <th class="cl-table-head cl-p-tiny ">
                <div>
                  File or folder name
                </div>
              </th>
              <th class="cl-table-head cl-p-tiny ">
                <div>
                  Last Modified
                </div>
              </th>
            </tr>
          </thead>
          @if (search_ongoing) {
            <tbody>
              <tr class="cl-tr-no-data">
                <td colspan="100" style="text-align: center">
                  <div class="cl-spinner">
                    Loading ...<i class="fas fa-spinner fa-spin"></i>
                  </div>
                </td>
              </tr>
            </tbody>

          } @else {
            @if (searchResults.items.length === 0) {
              <tbody>
                <tr class="cl-tr-no-data">
                  <td colspan="100" style="text-align: center">No files found.</td>
                </tr>
              </tbody>

            } @else {
              <tbody>
                @for (it of searchResults.items; track it) {
                  <tr>
                    <td>
                      <app-asset-icon [thing]="it.item"></app-asset-icon>
                    </td>
                    <td [class.cl-faded]="it.item.deleted">
                      <a [routerLink]=" it.item | link"
                        (click)="$event.stopPropagation()">
                        {{
                        it.item.id | remove:"s3://content-repo-.*-contentsupplier-" | orgResolver | middleTruncate: 100
                        }}
                      </a>
                    </td>
                    <td style="white-space: nowrap">
                      {{ it.item.last_modified | cldate }}
                    </td>
                  </tr>
                }
              </tbody>
            }
          }


        </table>
      </div>
    </div>
  </div>
</section>
</main>
